(function() {
  const LOG_PREFIX = '[UA Tabs Anchors]';

  function log(...args){ try { console.log(LOG_PREFIX, ...args); } catch(_) {} }
  function warn(...args){ try { console.warn(LOG_PREFIX, ...args); } catch(_) {} }
  function err(...args){ try { console.error(LOG_PREFIX, ...args); } catch(_) {} }

  log('script loaded');

  // ---------- helpers ----------
  function toHandle(str) {
    return (str || '')
      .toString()
      .trim().toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function parseHash() {
    const h = (window.location.hash || '').slice(1);
    if (!h) return { sectionId: null, anchor: null };
    const p = h.split(':');
    return p.length === 2 ? { sectionId: p[0], anchor: p[1] } : { sectionId: null, anchor: h };
  }
  function getTabNodes(ctrl) {
    // Flexible selectors for Ignite markup
    let nodes = Array.from(ctrl.querySelectorAll('div[role="tab"], label.custom-tab, .custom-tab[role="tab"]'));
    if (!nodes.length) {
      nodes = Array.from(ctrl.querySelectorAll('input[type="radio"]'))
        .map(i => i.closest('label') || i.parentElement)
        .filter(Boolean);
    }
    return nodes;
  }
  function resolveAnchor(map, a) {
    if (!a) return null;
    if (map[a]) return a;
    const keys = Object.keys(map);
    const c = [a + 's', a + 'es'];
    if (a.endsWith('es')) c.push(a.slice(0, -2));
    if (a.endsWith('s')) c.push(a.slice(0, -1));
    c.push(toHandle(a));
    return c.find(x => map[x]) || keys.find(k => k.startsWith(a)) || keys.find(k => k.includes(a)) || null;
  }
  function buildAnchorMap(ctrl) {
    const map = {};
    const tabs = getTabNodes(ctrl);
    tabs.forEach(function(tabEl, i) {
      const input = tabEl.querySelector('input[type="radio"]');
      if (!input) return;
      const titleNode = tabEl.querySelector('.tab-title, .title, span, strong') || tabEl;
      const raw = (titleNode.textContent || tabEl.textContent || '').trim();
      const anchor = toHandle(raw) || input.value;
      input.dataset.anchor = anchor;
      map[anchor] = input;
    });
    return map;
  }

  // ---------- bootstrap ----------
  function initTabs(ctrls) {
    const singleMode = ctrls.length === 1;
    log(`found ${ctrls.length} <section-tabs> (singleMode=${singleMode})`);

    ctrls.forEach(function(ctrl, idx) {
      const sectionEl = ctrl.closest('.shopify-section');
      if (!sectionEl || !sectionEl.id) { warn('no .shopify-section parent', ctrl); return; }
      const sectionId = sectionEl.id;

      const map = buildAnchorMap(ctrl);
      log(`section ${sectionId}: mapped ${Object.keys(map).length} tabs`, Object.keys(map));

      function applyHash() {
        const parsed = parseHash();
        if (!parsed.anchor) { log('no hash anchor present'); return; }
        if (!singleMode && parsed.sectionId && parsed.sectionId !== sectionId) return;

        if (singleMode && parsed.sectionId === sectionId) {
          // Clean namespaced -> plain when only one group
          history.replaceState(null, '', '#' + parsed.anchor);
          log(`cleaned namespaced hash to #${parsed.anchor}`);
        }

        const resolved = resolveAnchor(map, parsed.anchor);
        if (!resolved) { warn(`no tab matches "#${parsed.anchor}" in ${sectionId}`); return; }

        const input = map[resolved];
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true })); // Ignite shows the panel
        log(`activated "${resolved}" in ${sectionId}`);

        const label = input.closest('label') || input.closest('div[role="tab"]');
        if (label) label.scrollIntoView({ behavior: 'instant', block: 'start' });
      }

      // Keep hash in sync when user changes tabs
      ctrl.addEventListener('change', function(e) {
        const input = e.target && e.target.matches('input[type="radio"][data-anchor]') ? e.target : null;
        if (!input) return;
        const anchor = input.dataset.anchor || input.value;
        const hash = singleMode ? ('#' + anchor) : ('#' + sectionId + ':' + anchor);
        history.replaceState(null, '', hash);
        log(`hash updated to ${hash}`);
      });

      // Run immediately if Ignite already wired aria-controls / panels
      const wiredNow = ctrl.querySelector('[aria-controls]') ||
                       (ctrl.nextElementSibling && ctrl.nextElementSibling.matches && ctrl.nextElementSibling.matches('[role="tabpanel"]'));
      if (wiredNow) {
        log(`wired immediately for ${sectionId} → applying hash`);
        applyHash();
      } else {
        // Observe until Ignite sets aria-controls / role=tabpanel, then apply
        log(`waiting for Ignite wiring in ${sectionId}...`);
        const target = sectionEl.parentNode || document.body;
        const obs = new MutationObserver(function() {
          if (ctrl.querySelector('[aria-controls]')) {
            log(`detected aria-controls in ${sectionId} → applying hash`);
            obs.disconnect();
            applyHash();
          }
        });
        obs.observe(target, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-controls', 'role', 'id'] });
        // Safety fallback
        setTimeout(function() {
          if (ctrl.querySelector('[aria-controls]')) {
            log(`fallback timer hit; wiring present → applying hash`);
            obs.disconnect();
            applyHash();
          } else {
            warn(`fallback timer hit; wiring not detected — applying anyway`);
            obs.disconnect();
            applyHash();
          }
        }, 1200);
      }

      window.addEventListener('hashchange', applyHash);
    });
  }

  function bootstrap() {
    const ctrls = Array.from(document.querySelectorAll('section-tabs'));
    if (!ctrls.length) { warn('no <section-tabs> on page'); return; }
    initTabs(ctrls);
  }

  // Make sure the custom element exists, then bootstrap
  if (customElements.get('section-tabs')) {
    log('custom element already defined → bootstrap');
    bootstrap();
  } else {
    log('waiting for custom element definition…');
    customElements.whenDefined('section-tabs').then(function() {
      log('custom element defined → bootstrap');
      bootstrap();
    });
  }
})();
